import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyWeaveUpgradeIcon = lazy(() => import('./svg-components/weave-upgrade-icon'));

const WeaveUpgradeIcon = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyWeaveUpgradeIcon {...rest} />
  </Suspense>
);

export default WeaveUpgradeIcon;
